import { render } from "./siteFooter.vue?vue&type=template&id=76684612&scoped=true"
import script from "./siteFooter.vue?vue&type=script&lang=js"
export * from "./siteFooter.vue?vue&type=script&lang=js"

import "./siteFooter.vue?vue&type=style&index=0&id=76684612&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-76684612"]])

export default __exports__